<template>
  <v-main class="pa-2">

    <v-row>
      <v-col>
        <v-alert v-model="errorMessage" type="error" title="System Error">
          <strong>error URL: </strong> {{ this.errorURL }}
          <p>
            {{ this.errorText }}
          </p>
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-toolbar flat>
          <v-btn color="primary" dark @click.stop="dialog = true"><v-icon>mdi-plus</v-icon> <span class="text">Add
              Jump</span></v-btn>

          <v-btn @click.stop="newWalkIn()"><v-icon>mdi-basket-plus</v-icon> <span class="text">Merch Sale</span></v-btn>
          <v-spacer></v-spacer>

          <v-btn :disabled="groupPayJumpers.length < 1" :loading="loading" color="green"
            @click.stop="groupDialog = true"><v-icon>mdi-playlist-check</v-icon> <span class="text">Pay
              Together</span></v-btn>
          <v-dialog v-model="groupDialog" @keydown.esc="groupDialog = false" max-width="600px">
            <v-card>
              <v-card-title>
                Group Payment
              </v-card-title>

              <v-form @submit.prevent="payTogether" v-model="valid">
                <v-card-text>
                  <v-data-table class="no-footer-table" :headers="groupHeaders" :items="allGroupItems" item-key="id">

                    <template v-slot:item.price="{ item }">
                      <span>${{ item.price }} </span>
                    </template>
                    <template slot="body.append">
                      <tr class="pink--text">
                        <th class="title">Total</th>
                        <th class="title">${{ sum(allGroupItems, 'price') }}</th>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="groupDialog = false">Close</v-btn>

                  <v-btn :loading="groupLoading" color="green" type="Submit">
                    <v-icon left>mdi-playlist-check</v-icon>Paid </v-btn>
                </v-card-actions>
              </v-form>

            </v-card>
          </v-dialog>

        </v-toolbar>
      </v-col>
    </v-row>


    <v-row>

      <v-col cols="12" sm="6" md="6">
        <v-card class="pa-2" tile>
          <v-dialog v-model="dialog">

            <v-stepper vertical v-model="step">
              <v-row>
                <v-col cols=12 md="8">

                  <v-form @submit.prevent="save" v-model="valid" ref="customerDataForm">
                    <v-stepper-step :complete="saved" step="1">{{ formTitle }}
                      {{ editedItem.code }} - {{ editedItem.fullName }}

                      <small v-if="editedItem.bookingNumber">

                        <strong>Booking No.:</strong> {{ editedItem.bookingNumber }} </small>

                    </v-stepper-step>
                    <v-stepper-content step="1">

                      <v-row>
                        <v-col cols="12" md="6">


                          <fieldset class="inline-form">
                            <v-select v-model="editedItem.code" :items="products" :rules="codeRules" item-text="code"
                              item-value="code" :value="editedItem.code" label="Package">
                            </v-select>

                            <v-text-field :min="currentDate" v-if="!editedItem.bookingNumber" class="date-time-field"
                              type="datetime-local" v-model="editedItem.startTime" label="Date and Time"
                              :rules="startTimeRules"></v-text-field>
                          </fieldset>

                        </v-col>

                        <v-col cols="12" md="6">

                          <fieldset class="inline-form">
                            <v-select v-model="editedItem.creationAgent" :items="allAgentsNames" ref="agent" label="Agent"
                              item-text="name" item-value="name" :value="editedItem.creationAgent" persistent-hint
                              hide-details></v-select>

                            <v-select v-model="editedItem.transport" :items="['Bus', 'Airplane', 'Self Drive']" required
                              label="Transport">
                            </v-select>
                          </fieldset>
                        </v-col>
                      </v-row>
                      <v-row>

                        <v-col cols="12" md="6">


                          <v-text-field v-model="editedItem.fullName" label="Full Name" :rules="req"></v-text-field>

                          <v-text-field v-model="editedItem.IDnumber" label="Photo Identification #"
                            required></v-text-field>


                          <fieldset class="inline-form">
                            <v-text-field v-model="editedItem.dateOfBirth" type="date" label="DOB" required
                              :max="min_dob"></v-text-field>

                            <v-radio-group v-model="editedItem.gender">
                              <v-radio label="Male" value="Male"></v-radio>
                              <v-radio float-right label="Female" value="Female"></v-radio>

                            </v-radio-group>

                          </fieldset>


                          <fieldset class="inline-form">
                            <v-text-field type="number" v-model="editedItem.weight" label="Weight"
                              :rules="weightRules"></v-text-field>


                            <v-text-field type="number" v-model="editedItem.height" label="Height"></v-text-field>
                          </fieldset>


                        </v-col>



                        <v-col cols="12" md="6">
                          <v-text-field v-model="editedItem.address1" label="Address" required></v-text-field>

                          <fieldset class="inline-form">
                            <v-text-field v-model="editedItem.city" label="City" required></v-text-field>
                            <v-text-field v-model="editedItem.state" label="State" required></v-text-field>
                          </fieldset>

                          <fieldset class="inline-form">
                            <v-text-field v-model="editedItem.postcode" label="Zip Code" required></v-text-field>
                            <v-text-field v-model="editedItem.countryCode" label="Country"
                              :rules="countryCodeRules"></v-text-field>
                          </fieldset>


                          <fieldset class="inline-form">
                            <v-text-field v-model="editedItem.phoneNumber" label="Phone Number"></v-text-field>

                            <v-text-field v-model="editedItem.emailAddress" :rules="emailRules"
                              label="E-mail"></v-text-field>
                          </fieldset>

                        </v-col>

                        <v-col cols="12" md="6">

                          <v-radio-group v-model="pdf">
                            <v-radio label="Multiple Pages" value="multi"></v-radio>
                            <v-radio float-right label="1 Page" value="single"></v-radio>

                          </v-radio-group>
                        </v-col>


                        <v-col cols="12" md="6">
                        </v-col>

                      </v-row>

                      <v-card-actions>
                        <v-btn v-if="formTitle !== 'New Jump' || saved" :href="waiver" color="green darken-3">Get
                          Waiver</v-btn>
                        <v-spacer></v-spacer>

                        <v-btn :class="{ hidden: saved }" text @click="close">Cancel</v-btn>
                        <v-btn :class="{ hidden: saved }" color="blue darken-1" :disabled="!valid"
                          type="Submit">Save</v-btn>

                        <v-btn v-if="formTitle === 'New Jump'" @click="saveAndClose()" color="blue darken-1"
                          :disabled="!valid">Save and Close</v-btn>

                        <v-btn text :disabled="!saved" @click="nextStep">Continue</v-btn>
                      </v-card-actions>

                    </v-stepper-content>
                  </v-form>


                  <v-form @submit.prevent="addToBasket" v-model="validItems">
                    <v-stepper-step :complete="readyToPay" v-model="forLater" step="2">Add to Basket</v-stepper-step>

                    <v-stepper-content step="2">
                      <v-card-actions>
                        Total: <strong>$ {{ merch_total }}</strong>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" :disabled="!validItems" type="Submit"><v-icon
                            left>mdi-basket-plus</v-icon> Add</v-btn>

                        <v-btn v-if="editedItem.status == 1" text @click="skipMerch">Skip</v-btn>
                        <v-btn v-else text @click="close">Cancel</v-btn>


                      </v-card-actions>


                      <v-autocomplete @change="setItemValue" v-model="basket.billItems" :items="filteredMerch"
                        label="Search for Merch, Addons, Tips for TI or the Team, or Split Pack Payment" item-text="name" item-value="id" multiple
                        class="basket" :rules="req" hide-no-data prepend-icon="mdi-magnify" return-object>
                        <template v-slot:selection="data">
                          <template v-if="data.item.category === 'addons'">
                            <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
                              @click:close="removeBillItem(data.item)" outlined label>

                              {{ data.item.name }} ${{ data.item.price }}
                            </v-chip>
                          </template>

                          <template v-else>
                            <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select"
                              @click:close="removeBillItem(data.item)" outlined label>

                              {{ data.item.name }} | {{ data.item.m_l }} | {{ data.item.colour }} | {{ data.item.size }} $
                              {{ data.item.price }}
                            </v-chip>
                          </template>


                        </template>
                        <template v-slot:item="data">
                          <template v-if="data.item.category !== 'merch'">
                            <v-list-item-content v-text="data.item.name + ' $' + data.item.price"></v-list-item-content>
                          </template>
                          <template v-else-if="data.item.category === 'merch'">

                            <v-list-item-content>
                              <!-- <v-list-item-title v-html="data.item.name"></v-list-item-title> -->
                              <!-- <v-list-item-subtitle v-html="'$' + data.item.price"></v-list-item-subtitle> -->
                              {{ data.item.name }} | {{ data.item.m_l }} | {{ data.item.colour }} | {{ data.item.size }} $
                              {{ data.item.price }}
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-autocomplete>
                      <small>Total Items <b>{{ filteredMerch.length }}</b></small>
                      <v-list v-for="item in customItemsValues" :key="item.id">
                        <v-list-item>
                          <template v-slot:default="">

                            <template v-if="item.category === 'tips'">
                              <v-list-item-content>
                                  <v-select v-if="item.name == 'Individual Tip'" 
                                  item-text="name" item-value="name"
                                  v-model="item.notes" :items="instructors" :rules="req" label="Instructor's name"
                                  ></v-select>
                                <label v-else>Team Tip</label>

                              </v-list-item-content>
                              <v-list-item-action>
                                <v-text-field v-model.number="item.price" type="number" :rules="priceReq" label="Amount"
                                  prefix="$"></v-text-field>
                              </v-list-item-action>
                            </template>

                            <template v-else>
                              <v-list-item-content>
                                Enter an amount betwen 20 and {{ editedItem.price - 20 }}

                              </v-list-item-content>
                              <v-list-item-action>
                                <v-text-field v-model="item.price" type="number" :rules="[min_max]" label="Amount"
                                  prefix="$"></v-text-field>
                              </v-list-item-action>
                            </template>
                          </template>
                        </v-list-item>
                      </v-list>
                      <FilterMerch />
                    </v-stepper-content>

                  </v-form>



                </v-col>

                <v-col cols="12" md="4">

                  <v-form @submit.prevent="pay" v-model="validPayment">

                    <v-stepper-step step="3">Payment</v-stepper-step>

                    <div class="payment">
                      <v-stepper-content step="3">

                        <div v-if="editedItem.code">
                          <v-checkbox @change="deductPckg()"
                            :disabled="(splitPayBalance !== null && splitPayBalance !== undefined) || (editedItem.creditedItems && editedItem.creditedItems.length > 0) || isPrepaidAgent"
                            :class="{ hidden: editedItem.status == 2 }" v-model="editedItem.prepaidBooking"
                            label="Prepaid Booking" />


                          <v-text-field prefix="$" :class="{ hidden: editedItem.status == 2 }" ref="price" readonly
                            type="number" v-model="price"
                            :label="editedItem.productName || 'Package Price'"></v-text-field>

                          <v-text-field :class="{ hidden: editedItem.status == 2 }" prefix="$"
                            :disabled="editedItem.prepaidBooking" class="discount" type="number"
                            v-model.number="editedItem.discount" label="Package Discount"></v-text-field>

                          <v-text-field v-if="editedItem.status == 1" prefix="$" :class="{ hidden: overweight == 0 }"
                            type="number" readonly v-model.number="overweight"
                            :label="owSurcharge[0].name"></v-text-field>
                        </div>


                        <Bill :items="editedItem.creditedItems" :status="editedItem.status"
                          :customer_id="editedItem.customer_id" @removefromBasket="removeBillItem" />
                        <Purchased :items="allItems" :status="editedItem.status" :customer_id="editedItem.customer_id"
                          @removefromBasket="removeBillItem" />


                        <v-text-field type="number" readonly v-model="merch_total" prefix="$"
                          label="Merch & Addons"></v-text-field>

                        <span :class="{ hidden: editedItem.status == 2 }">Balance:
                          <strong>$ {{ total }}</strong>
                        </span>


                        <v-radio-group :disabled="splitPayBalance !== null && splitPayBalance !== undefined"
                          v-model="editedItem.paymentMethod" :rules="req" flex>
                          <v-radio label="CC" value="CC"></v-radio>
                          <v-radio label="Cash" value="Cash"></v-radio>

                        </v-radio-group>

                        <v-text-field v-model="editedItem.notes" label="Notes"></v-text-field>

                        <v-card-actions v-if="editedItem.code">

                          <v-btn :loading="loading" color="green" type="Submit" :disabled="!validPayment || step < 3">
                            <v-icon left>mdi-account-check</v-icon>Paid </v-btn>

                          <v-btn v-if="editedItem.status == 1" text @click="groupPay()" :disabled="step < 3">
                            <v-icon left>mdi-basket-plus</v-icon> Group Payment</v-btn>
                        </v-card-actions>

                        <v-card-actions v-else>
                          <v-btn color="green" @click="walkInPay()">
                            <v-icon left>mdi-cash-check</v-icon> Paid</v-btn>
                        </v-card-actions>

                      </v-stepper-content>
                    </div>
                  </v-form>

                </v-col>
              </v-row>
            </v-stepper>

          </v-dialog>
          <v-data-table :headers="headers" :items="jumps" :items-per-page="30" disable-pagination item-key="id"
            :loading="loading" show-expand :expanded.sync="expanded">
            <template v-slot:item.group="{ item }">
              <v-checkbox v-if="item.group == 1" :value="item.id" v-model="groupPaymentIDs"></v-checkbox>
            </template>

            <template v-slot:item.actions="{ item }">

              <v-btn icon color="primary" class="mx-2" @click="checkIn(item)">
                <v-icon>mdi-account-check</v-icon>
              </v-btn>
            </template>


            <template v-slot:expanded-item="{ headers, item }">

              <td :colspan="headers.length" v-if="item.notes || item.merch.length > 0">
                <Bill :items="item.merch" :status="item.status" :customer_id="item.customer_id" />
                <p>Notes: {{ item.notes }}</p>
              </td>
            </template>


          </v-data-table>


        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <WithAddons @edit-checkedIn="checkIn" @addMerchStep="addMerch" />

      </v-col>
    </v-row>
    <RecentlyAddedJumps /> 
  </v-main>
</template>

<style>
.basket {
  margin-bottom: 5em
}


.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: row;
  justify-content: space-around;

  label {
    margin: 0;
  }
}

.discount .v-input input:disabled {
  color: transparent;
}

h3 {
  text-align: right;
}

.hidden {
  display: none;
}

a:hover,
a:focus {
  text-decoration: none;
}

input[type=datetime-local],
.date-time-field {
  width: 80%;
  max-width: 80%;
  justify-content: flex-start
}


.method.v-input--radio-group--column .v-input--radio-group__input {
  flex-direction: column;
}

@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {

  form .v-input--radio-group--column .v-input--radio-group__input {
    flex-direction: column;
  }

  form .v-card__actions .v-input--radio-group--column .v-input--radio-group__input {
    flex-direction: row;
  }

}

.v-toolbar__content .v-btn {
  margin-right: 1%
}

@media only screen and (max-width : 480px) {

  span.text {
    display: none
  }
}

@media only screen and (orientation: landscape) and (max-device-width : 480px) {
  span.text {
    display: none
  }
}
</style>


<script>
import { mapState } from 'vuex'

import WithAddons from '../components/WithAddons.vue'
import FilterMerch from '../components/FilterMerch.vue'
import Purchased from '../components/Purchased.vue'
import GroupPayment from '../components/GroupPayment.vue'
import Bill from '../components/Bill.vue'
import RecentlyAddedJumps from '../components/RecentlyAddedJumps.vue'

export default {
  components: {
    WithAddons,
    FilterMerch,
    Purchased,
    Bill,
    GroupPayment,
    RecentlyAddedJumps
  },
  data() {
    return {
      dialog: false,
      forLater: false,
      errorMessage: false,
      errorURL: "",
      errorText: "",

      headers: [
        { text: '', value: 'group', align: 'start', sortable: true },
        // { text: 'Date', align: 'start', sortable: false, value: 'startTime', dataType: "Date"},
        { text: 'Pckg', align: 'start', sortable: true, value: 'code', },
        { text: 'Jumper', align: 'start', sortable: true, value: 'fullName' },
        { text: 'Agent', align: 'start', sortable: true, value: 'creationAgent' },
        { text: '', value: 'actions', sortable: false },
      ],

      groupDialog: false,
      groupLoading: false,


      groupHeaders: [
        { text: 'Item', value: 'name', align: 'start', sortable: true },
        { text: 'Price', align: 'start', sortable: false, value: 'price' },
      ],

      //Edit Customer Data Form:
      valid: true,

      editedIndex: -1,
      saved: false,
      loaded: false,
      loading: false,
      waiver: '/fillwaiver/',


      //Placeholder :
      editedItem: {
        fullName: '',
        dateOfBirth: '',
        gender: '',
        weight: 0,
        height: 0,

        address1: '',
        city: '',
        postcode: '',
        phoneNumber: '',
        state: '',
        countryCode: '',
        emailAddress: '',
        creationAgent: '',

        startTime: '',

        overweight: 0,
        instructor_id: null,
        agent_id: null,
        discount: 0,
        price: this.price,
        paymentMethod: 'CC',
        transport: '',
        tips: 0,
        notes: '',
        code: '',
        prepaidBooking: false,

        groupPayment: false,
        creditedItems: [],
        merch: []

      },


      basket: {
        customer_id: null,
        billItems: [], //IDs
        bookingItems: [] //IDs
      },


      prepaidBooking: false,

      allItems: [],

      validItems: false,
      customItemsValues: [],

      readyToPay: false,
      validPayment: false,
      newJump: true,
      addon: null,
      discount: 0,
      transport: '',

      pdf: 'multi',

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      weightRules: [
        v => !!v || 'Required',
      ],
      codeRules: [
        v => !!v || 'Required',
      ],
      startTimeRules: [

        v => !!v || 'Date and Time are required',
      ],

      countryCodeRules: [
        v => !!v || 'Country Code required',

      ],

      priceReq: [
        v => !!v || 'Required',
      ],

      req: [v => !!(v && v.length) || 'Item is required'],


      step: 1,
      groupPaymentIDs: []




    }
  },

  mounted() {

    this.$store.dispatch('fetchData')
    this.$store.dispatch('fetchAgents')
    if (this.merch.length == 0)
      this.$store.dispatch('fetchAllMerch')

      if ( this.instructors.length == 0)
        this.$store.dispatch('fetchInstructors')
  },

  computed: {
    ...mapState(['products', 'agents']),


    instructors() {

    return this.$store.getters.activeInstructors

    },



    jumps() {
      return this.$store.getters.booked
    },

    currentDate() {

      let now = new Date()
      return now.yyyymmdd() + "T00:00:00"

    },
    expanded: {

      get() {
        return this.jumps
      },

      set(items) {
        return items
      }
    },

    customers() {

      return this.$store.getters.checkedin

    },


    prepaidAgents() {

      return this.agents.filter((a) => {

        return a.prepaid

      }).map(a => {

        return a.name
      })
    },


    isPrepaidAgent() {

      return this.prepaidAgents.includes(this.editedItem.creationAgent)
    },



    allAgentsNames() {

      this.$store.state.agents.unshift(
        {
          id: null,
          name: null,
          email: null,
          prepaid: false,
          phone: null,
          commission: 0,
        })

      return this.agents.map(a => a.name)

    },


    min_dob() {
      var d = new Date()

      d.setFullYear(d.getFullYear() - 18)
      var month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-')
    },


    owSurcharge() {

      return this.$store.state.merch.filter((el) => {
        return el.category == 'ow'
      })

    },

    allJumpers() {
      return this.$store.state.customers
    },


    groupPayJumpers() {

      return this.allJumpers.filter((el) => {
        return this.groupPaymentIDs.includes(el.id)
      })

    },


    allGroupItems() {


      let all = this.groupPayJumpers.reduce((a, { merch }) => [...a, ...merch], [])


      return all.filter((el) => {
        return el.pivot.paymentStatus == 'pending'
      })
    },

    merch() {

      return this.$store.state.merch.filter((el) => {
        return el.category !== 'pckg' && el.category !== 'ow'
      })

    },


    filteredMerch() {
      return this.$store.getters.filteredMerch
    //  let filteredMerch =  this.$store.getters.filteredMerch

    //   return !this.editedItem.code ? filteredMerch.filter((el) => {
    //     return el.name !== 'Individual Tip'
    //   }) : filteredMerch
    },




    pckgs() {
      return this.$store.state.merch.filter((el) => {

        return el.category === 'pckg'
      })
    },


    formTitle() {


      if (this.editedItem.id) {


        if (this.editedItem.status === 1) { return 'Check-in' }

        else {

          if (!this.editedItem.code)
            return "Shop Customer"
          else
            return 'Edit'
        }

      }
      else { return 'New Jump' }

    },

    creditedItems() {

      return this.editedItem.creditedItems || []

    },

    noPckgCredit() {

      const noPckgCredit = this.creditedItems.filter((c) => {

        return c.category != 'pckg'

      })

      return noPckgCredit.length > 0 ? this.sumTotals(noPckgCredit, "price") : 0
    },


    pckgCredit() {

      const pckgCredit = this.editedItem.creditedItems ? this.editedItem.creditedItems.filter((c) => {

        return c.category == 'pckg'

      }) : []



      return pckgCredit.length > 0 ? pckgCredit[0].price : 0
    },


    owCredit() {

      const owCredit = this.editedItem.creditedItems.filter((c) => {
        return c.category == 'ow'

      })



      return owCredit.length > 0 ? owCredit[0].pivot.price : 0
    },

    selProdObject() {

      const selProduct = this.editedItem.code ? this.products.find(x => x.code === this.editedItem.code) : null


      this.editedItem.productName = selProduct ? selProduct.name : this.editedItem.productName
      return selProduct

    },


    price: {

      get() {

        const discount = this.editedItem.discount !== "" ? parseFloat(this.editedItem.discount) : 0


        var pckg_price = this.editedItem.code ? this.selProdObject.price : 0;

        pckg_price = this.splitPayBalance ? pckg_price - parseFloat(this.splitPayBalance.price) : pckg_price

        pckg_price = this.pckgCredit > 0 ? pckg_price - this.pckgCredit : pckg_price

        pckg_price = discount != 0 ? pckg_price - discount : pckg_price

        pckg_price = discount != 0 ? pckg_price - discount : pckg_price
        return pckg_price || 0

      },

      set(val) {

        this.editedItem.price = val
        return val
      }
    },

    splitPayBalance() {


      return this.basket.billItems.length > 0 ? this.basket.billItems.find(m => m.category === 'split') : null

    },

    overweight: {

      get() {

        var w = parseFloat(this.editedItem.weight)

        if (w >= 210 && w <= 230) {

          this.owSurcharge[0].name = "WC1"
          return this.$store.state.owc.wc1 + this.owCredit



        } else if (w > 230) {

          this.owSurcharge[0].name = "WC2"
          var ow = ((w - 230) * this.$store.state.owc.wc2) + this.$store.state.owc.wc1
          return ow + this.owCredit
        }
        else {
          return 0;
        }

      },

      set(val) {
        return val
      }
    },

    selectedMerch() {

      const bill = this.merch.filter((el) => {

        return this.basket.billItems.includes(el)

      })


      bill.forEach(function (el) {

        el.price = el.price !== "" ? parseInt(el.price) : 0
      })


      return bill

    },




    merch_total() {


      const noCredit = this.basket.billItems.filter((el) => {

        return el.category !== 'split'

      })

      return noCredit.length > 0 ? this.sumTotals(noCredit, 'price') : 0
    },


    total: {

      get() {

        var p = this.editedItem.prepaidBooking ? 0 : parseFloat(this.price) || 0

        // if ( this.editedItem.creditedItems && this.editedItem.creditedItems.length > 0 )
        //       return this.merch_total
        // else 

        return (p + parseFloat(this.overweight) + this.merch_total) - this.noPckgCredit || 0
      },

      set(val) {

        return val
      }

    }



  },

  watch: {

    dialog(val) {


      val || this.close()
    },


    saved(val) {

      this.waiver = '/fillwaiver/' + this.pdf + '/' + this.editedItem.customer_id;

    },




    pdf(format) {
      this.waiver = '/fillwaiver/' + format + '/' + this.editedItem.customer_id;
    },

    valid(valid) {


      if (!valid) {
        this.editedItem.discount = !("discount" in this.editedItem) ? 0 : this.editedItem.discount;
        this.editedItem.tips = !("tips" in this.editedItem) ? 0 : this.editedItem.tips;
      }
    }


  },

  methods: {

    isPast(transactionDate) {

      var today = new Date().yyyymmdd()
      today = new Date(today + "T00:00:00")

      transactionDate = new Date(transactionDate).yyyymmdd()
      transactionDate = new Date(transactionDate + "T00:00:00")

      return transactionDate.getTime() < today.getTime()

    },


    //so the ow doesn't round up
    sumTotals(items, prop) {

      return items.reduce(function (a, b) {
        return a + parseFloat(b[prop]);
      }, 0);
    },


    deductPckg() {
      if (this.editedItem.prepaidBooking) {

        this.prepaidBooking = true
      } else {
        this.prepaidBooking = false
      }

    },

    cancelJump(item) {


      const index = this.jumps.indexOf(item)


      confirm('Are you sure you want to cancel this jump?') &&
        axios.put('/api/jumps/cancel/' + item.id)
          .then(response => {

            // console.log(response.data)
            this.customers.push(response.data)
            this.jumps.splice(index, 1)

          })
          .catch(err => {
            this.errorMessage = err
            this.errorText = err.response.request.response
            this.errorURL = err.response.request.responseURL

          })

    },


    checkIn(item) {


      this.editedIndex = this.jumps.indexOf(item)
      this.editedItem = Object.assign({}, item)
  

      this.waiver = '/fillwaiver/' + this.pdf + '/' + this.editedItem.customer_id
      this.basket.customer_id = this.editedItem.customer_id
      this.editedItem.paymentMethod = 'CC'

      this.editedItem.prepaidBooking = this.prepaidBooking ? true : false

      this.newJump = false

      this.editedItem.creditedItems = this.editedItem.merch ? this.editedItem.merch.filter(m => {

        return new Date(m.pivot.created_at).isPast() && m.category != 'merch' && m.pivot.paymentStatus == 'paid'

      }) : []



      if (this.editedItem.creditedItems && this.editedItem.creditedItems.length > 0) {

        this.editedItem.creditedItems.forEach(function (el) {

          el.paymentStatus = 'credit'
          el.pivot.price = -el.pivot.price

        })

      }


      this.dialog = true

    },


    saveAndClose() {

      this.forLater = true
      this.save()
    },


    close() {
      this.dialog = false
      this.$nextTick(() => {

        this.editedItem = Object.assign({}, this.defaultItem)


        this.editedIndex = -1
        this.saved = false
        this.step = 1
        this.forLater = false
        this.loading = false
        this.basket.billItems = []
        this.allItems = []

      })
    },



    save() {

      this.editedItem.overweight = this.overweight
      this.editedItem.prepaidBooking = this.isPrepaidAgent ? true : false


      this.editedItem.price = this.editedItem.price ? this.editedItem.price : this.price



      if (this.formTitle !== 'New Jump') {

        axios.put('/api/jumps/' + this.editedItem.jumpId, this.editedItem)
          .then(response => {


            this.saved = true

            if (this.forLater == true) { this.close() }

          })
          .catch(err => {

            this.errorMessage = err
            this.errorText = err.response.request.response
            this.errorURL = err.response.request.responseURL

            this.close()

          })


      } else {


        this.editedItem.discount = !("discount" in this.editedItem) ? 0 : this.editedItem.discount;


        this.editedItem.client_id = this.$store.state.uuid

        axios.post('/api/jumps', this.editedItem)
          .then(response => {

            response.data[0].jumpId = response.data[0].id

            this.$store.dispatch('fetchData')
            this.checkIn(response.data[0])
            this.$store.dispatch('getRecentlyAddedJumps')

            this.saved = true


            if (this.forLater == true) {

              this.close()

            }


          })
          .catch(err => {
            this.errorMessage = err
            this.errorText = err.response.request.response
            this.errorURL = err.response.request.responseURL

            this.close()

          })

      }

      this.basket.customer_id = this.editedItem.customer_id

    },

    nextStep() {
      this.step = 2

    },


    addMerch(item) {

      this.nextStep()
      this.checkIn(item)

    },


    newWalkIn() {

      axios.post('/api/customers/storeWalkin/' + this.$store.state.uuid)
        .then(response => {

          this.nextStep()

          this.editedItem = Object.assign({}, response.data)

          this.editedItem.status = 2

          this.basket.customer_id = this.editedItem.id
          this.editedItem.paymentMethod = 'CC'
          this.newJump = false
          this.dialog = true

        })
    },


    addToBasket() {

      this.basket.billItems.forEach(function (el) {

        el.price = el.price !== "" ? parseFloat(el.price) : 0
        el.paymentStatus = "pending"
        el.notes = el.notes ? el.notes : el.name
      })

      this.allItems = this.basket.billItems

      this.readyToPay = true
      this.step = 3

    },

    removeBillItem(item) {
      const index = this.basket.billItems.indexOf(item),
        customAmountIndex = this.customItemsValues.indexOf(item)


      if (index >= 0) this.basket.billItems.splice(index, 1)
      if (customAmountIndex >= 0) this.customItemsValues.splice(customAmountIndex, 1)

      if (this.basket.billItems.length == 0 && this.editedItem.status == 2) this.close()
    },


    skipMerch() {

      this.basket.billItems = []
      this.readyToPay = true
      this.step = 3

    },

    setItemValue(val) { //called on change


      if (val.length > 0) {

        this.customItemsValues = this.merch.filter(item => {

          return val.includes(item) && (item.category == 'tips' || item.category == 'split')
        })

      }


    },

    min_max(val) { //split Pay Validation

      return val >= 20 && val <= (parseFloat(this.editedItem.price) - 20)
    },

    groupPay() {

      this.editedItem.group = 1
      this.pay()

    },

    payTogether() {

      this.loading = true

      this.groupPayJumpers.forEach(function (el) {
        el.status = 2

      })

      axios.put('/api/customers/payTogether',
        { jumpers: this.groupPayJumpers })
        .then(response => {

          location.reload()

        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL

          this.groupDialog = false
        })
    },


    walkInPay() {

      this.loading = true

      var selectedMethod = this.editedItem.paymentMethod,
        allItems = this.allItems

      allItems.forEach(function (el) {

        el.paymentMethod = selectedMethod
        el.paymentStatus = "paid"
        el.notes = el.notes ? el.notes : el.name
      })



      axios.put('/api/customers/shop/' + this.basket.customer_id,
        { billItems: allItems })
        .then(response => {

          this.close()


        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL

          this.close()
        })

    },


    pay() {

      this.loading = true

      if (this.editedItem.status == 1) {


        var pckg = this.pckgs.find(x => x.name === this.selProdObject.name)

        pckg.price = this.editedItem.price = this.price //package Price after discounts
        pckg.notes = pckg.name
        pckg.paymentStatus = this.editedItem.group == 1 ? 'pending' : 'paid'


        var addBookingCharges = true

        if (!this.newJump) {

          if (this.editedItem.creditedItems && this.editedItem.creditedItems.length > 0) {

            addBookingCharges = false
          }
        }

        if (addBookingCharges) // Don't charge for pckg if credit
          this.basket.bookingItems.push(pckg) //package

        if (this.overweight > 0 && this.owCredit == 0) {

          this.owSurcharge[0].price = this.overweight
          this.owSurcharge[0].name = this.overweight > 35 ? "WC2" : "WC1"
          this.owSurcharge[0].paymentStatus = this.editedItem.group == 1 ? 'pending' : 'paid'

          if (addBookingCharges)
            this.basket.bookingItems = this.basket.bookingItems.concat(this.owSurcharge)

        }


        this.allItems = this.allItems.concat(this.basket.bookingItems)


      }


      var selectedMethod = this.editedItem.paymentMethod,
        prepaidBooking = this.editedItem.prepaidBooking,
        allItems = this.allItems,
        group = this.editedItem.group


      this.editedItem.paymentMethod = prepaidBooking ? 'prepaid' : this.editedItem.paymentMethod

      allItems.forEach(function (el) {
        el.paymentMethod = el.category !== 'split' ? selectedMethod : 'Cash'




        if (group == 0) {

          el.paymentStatus = el.paymentStatus == 'pending' ? 'paid' : el.paymentStatus
        }


        el.paymentMethod = prepaidBooking && el.category == 'pckg' ? 'prepaid' : el.paymentMethod

        el.notes = el.notes ? el.notes : el.name
      })


      axios.put('/api/customers/shop/' + this.basket.customer_id,
        { billItems: allItems })
        .then(response => {

          if (this.editedItem.group == 0) {

            this.editedItem.status = this.editedItem.status == 1 ? 2 : this.editedItem.status //checkin if not checked in yet
            this.jumps.splice(this.editedIndex, 1)
          }

          this.save()
          this.close()
          location.reload()

        })
        .catch(err => {
          this.errorMessage = err
          this.errorText = err.response.request.response
          this.errorURL = err.response.request.responseURL

          this.close()
        })


    }

  }
}
</script>
